import gsap from 'gsap';
import Sniffer from 'sniffer';

import { app } from '@/utils/store';

class Services {
  constructor() {
    this.services = {
      el: document.querySelector('.s-services'),
      row: document.querySelectorAll('.services-row'),
    };
  }

  init() {
    document.fonts.ready.then(() => {
      this.set();
    });

    this.events();
  }

  set = () => {
    [...this.services.row].forEach((i) => {
      const h = i.querySelector('h4').getBoundingClientRect();
      const p = i.querySelector('p').getBoundingClientRect();
      gsap.set(i, {
        height: h.height + p.height,
      });
      app.scroll.resize();
    });
  }

  events = () => {
    [...this.services.row].forEach((e) => {
      e.addEventListener('click', this.toggle);
    });
  }

  toggle = (e) => {
    const r = e.target.closest('.services-row');
    const m = r.querySelector('.services-mask');

    [...this.services.row].forEach((i) => {
      const h = i.querySelector('h4').getBoundingClientRect();
      const p = i.querySelector('p').getBoundingClientRect();
      gsap.to(i, {
        duration: 1,
        ease: 'expo.out',
        height: h.height + p.height,
      });
    });

    setTimeout(() => {
      let o;
      const b = r.getBoundingClientRect().top;
      if (Sniffer.isPhone) {
        o = -b + app.scroll.data.current + window.innerWidth * 0.22667;
      } else {
        o = -b + app.scroll.data.current + window.innerWidth * 0.05208;
      }
      app.scroll.data.current = o;
      app.scroll.resize();
    }, 1000);

    if (r.classList.contains('is-active')) {
      [...this.services.row].forEach((i) => {
        i.classList.remove('is-active');
      });
      return;
    }

    [...this.services.row].forEach((i) => {
      i.classList.remove('is-active');
    });

    r.classList.add('is-active');

    gsap.to(r, {
      duration: 1,
      ease: 'expo.out',
      height: m.getBoundingClientRect().height,
    });
  }
}

export default Services;
